'use client';
import styled from 'styled-components';

import { Sizes, Spacers } from '@styles/theme';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;

export const ImageContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: ${Spacers.XS}rem;
  height: ${Sizes.LISTING_IMAGE};
  width: 100%;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${Spacers.XS}rem;
`;

export const RadioGroup = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;
